(function () {
  'use strict';

  // The Kit Dealer — storefront fixes for the Ella theme.
  // Loaded as a theme asset (assets/kd-fixes.js).

  // ── Fix 1 ──────────────────────────────────────────────────────────────
  // Tapping the mobile "Sort" tab must open the SORT sheet — not the filter
  // drawer. We take ownership of the tap (capture phase + stopPropagation)
  // and set the exact state the theme uses to reveal the sort sheet:
  //   body.toolbar-modal-open  +  sortTab[aria-expanded="true"]
  // and we make sure the filter drawer (open-mobile-sidebar) is never left
  // open underneath it.
  document.addEventListener('click', function (e) {
    var target = e.target;
    var sortTab = target && target.closest &&
      target.closest('.label-tab[data-mobile="mobile"][data-toggle="dropdown"]');
    if (!sortTab) return;

    e.stopPropagation();
    document.body.classList.remove('open-mobile-sidebar');

    var isOpen = sortTab.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      sortTab.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('toolbar-modal-open');
    } else {
      sortTab.setAttribute('aria-expanded', 'true');
      document.body.classList.add('toolbar-modal-open');
    }
  }, true);

  // ── Fix 2 + 3 (CSS) ─────────────────────────────────────────────────────
  // Fix 2: the funnel icon on the black "Filter" button was dark-on-dark
  //        (invisible) — make it follow the button's text colour.
  // Fix 3: keep the two hidden "_internal-customisation-*" add-on products
  //        (Player Nameset, Patches) out of the catalogue + search. They must
  //        stay published so they can be added to the cart as line items, but
  //        must never appear as standalone products to browse.
  var css =
    // Fix 2 — filter icon visible
    '.toolbar .toolbar-item .toolbar-icon.icon-filter svg,' +
    '.toolbar .toolbar-item .toolbar-icon.icon-filter svg path' +
    '{fill:currentColor !important;}' +
    // Fix 3 — hide add-on product cards wherever they list
    'li.product:has(a[href*="/products/_internal-customisation-"]),' +
    '.product-grid-item:has(a[href*="/products/_internal-customisation-"]),' +
    '.item-product:has(a[href*="/products/_internal-customisation-"]),' +
    '.grid-product:has(a[href*="/products/_internal-customisation-"])' +
    '{display:none !important;}';
  var style = document.createElement('style');
  style.setAttribute('data-kd-fixes', '');
  style.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(style);

  // Fix 3 (JS) — belt-and-braces for browsers without :has() and for cards
  // injected later by AJAX (filtering / infinite scroll). Hide any product
  // card that links to an internal add-on product.
  function hideAddonCards(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    var links = root.querySelectorAll('a[href*="/products/_internal-customisation-"]');
    for (var i = 0; i < links.length; i++) {
      var card = links[i].closest(
        'li.product, .product-grid-item, .item-product, .grid-product, li, .item'
      );
      if (card) card.style.setProperty('display', 'none', 'important');
    }
  }

  // Fix 3 (guard) — if someone lands on an add-on product page directly,
  // send them to the shop instead of letting it sell as a standalone item.
  if (location.pathname.indexOf('/products/_internal-customisation-') === 0) {
    location.replace('/collections/all');
    return;
  }

  // ── Fix 4 ──────────────────────────────────────────────────────────────
  // Hide the "Size Guide" accordion on collectible listings that have no real
  // sizing (Panini sticker box + single pack). Scoped by URL so NO other
  // product is affected — to add more, append their /products/<handle> path.
  var KD_NO_SIZE_GUIDE = [
    '/products/panini-fifa-world-cup-2026-sticker-collection-sealed-50-pack-display-box',
    '/products/panini-fifa-world-cup-2026-stickers-single-pack-5-stickers'
  ];
  if (KD_NO_SIZE_GUIDE.indexOf(location.pathname) !== -1) {
    var sgStyle = document.createElement('style');
    sgStyle.setAttribute('data-kd-fixes-sizeguide', '');
    sgStyle.appendChild(document.createTextNode(
      '#sizing-chart-section,#sizing-chart-toggle{display:none !important;}'
    ));
    (document.head || document.documentElement).appendChild(sgStyle);
  }

  function runHide() { try { hideAddonCards(document); } catch (e) {} }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runHide);
  } else {
    runHide();
  }
  window.addEventListener('load', runHide);
  [0, 300, 800, 1500].forEach(function (t) { setTimeout(runHide, t); });
  // PERF 2026-08-24: this observer used to call runHide() on EVERY DOM mutation
  // anywhere in the body, unthrottled. hideAddonCards() does a full-document
  // querySelectorAll plus a .closest() per hit, and lazysizes mutates every
  // product image while you scroll — so on a throttled phone this burned
  // 3,395 ms of CPU (29% of all scroll CPU) across a 3-second scroll and was
  // the main cause of the cards stuttering. Now coalesced to at most one run
  // per animation frame, and skipped entirely for mutations that added no
  // element nodes. Same behaviour, a fraction of the work.
  try {
    var kdHidePending = false;
    new MutationObserver(function (records) {
      if (kdHidePending) return;
      var worthIt = false;
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) { worthIt = true; break; }
      }
      if (!worthIt) return;
      kdHidePending = true;
      requestAnimationFrame(function () { kdHidePending = false; runHide(); });
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  // ── Fix 5 ──────────────────────────────────────────
  // The product-page "Ask A Question" tab is a hand-built contact form
  // (templates/product.json -> main-product -> custom block "Ask A Question").
  // Its HTML is identical for every product, so the email reaching the support
  // inbox never said WHICH product the question was about. Shopify section
  // settings are not rendered through Liquid, so we attach the product identity
  // client-side. Hidden field names mirror the theme's native "Ask an expert"
  // form (Product Title / Product Image / Product Link) so the contact-form
  // email shows them as ordinary rows.
  function kdMeta(sel, attr) {
    var el = document.querySelector(sel);
    return el ? (el.getAttribute(attr) || '').trim() : '';
  }
  function kdCleanTitle(t) {
    return (t || '').replace(/\s*[\u2014\u2013-]\s*The Kit Dealer\s*$/i, '').trim();
  }
  function kdAddHidden(form, name, value) {
    if (!value) return;
    if (form.querySelector('input[name="' + name + '"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
  function kdTagAskAQuestionForms() {
    var forms = document.querySelectorAll('.ask-a-question-form form');
    if (!forms.length) return;

    var h = document.querySelector('.productView-title, h1.product-single__title, h1');
    var title = h ? h.textContent.trim() : '';
    if (!title) title = kdCleanTitle(kdMeta('meta[property="og:title"]', 'content'));
    title = kdCleanTitle(title);
    if (!title) return;

    var link = kdMeta('link[rel="canonical"]', 'href') ||
      (location.origin + location.pathname);
    var image = kdMeta('meta[property="og:image"]', 'content').replace(/^http:\/\//i, 'https://');

    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.getAttribute('data-kd-product-tagged') === '1') continue;
      form.setAttribute('data-kd-product-tagged', '1');
      kdAddHidden(form, 'contact[Product Title]', title);
      kdAddHidden(form, 'contact[Product Image]', image);
      kdAddHidden(form, 'contact[Product Link]', link);
    }
  }
  function kdRunFormTag() { try { kdTagAskAQuestionForms(); } catch (e) {} }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kdRunFormTag);
  } else {
    kdRunFormTag();
  }
  window.addEventListener('load', kdRunFormTag);
  [0, 300, 800, 1500].forEach(function (t) { setTimeout(kdRunFormTag, t); });

// ==== TKD SEARCH SCOPE v2 (2026-08-02) — START ====
  // Title-scoped search (why: SEARCH_SCOPE_CHANGE_LOG.md). v2 guarantees the
  // scoped "(title:... OR vendor:...)" syntax is NEVER visible to customers:
  // v1 rewrote the visible input at submit time, so Chrome stored the raw
  // syntax in autofill and restored it on back/forward + session restore.
  // v2 leaves the input alone and navigates to the scoped URL instead, and
  // the cleaner below runs on every page (v1 only ran it on /search).
  function kdIsScoped(q) { return String(q).indexOf(':') !== -1; }
    // KD 2026-08-21: club nicknames. kdScopeQ requires EVERY word to appear in the product
  // TITLE, so "man utd", "spurs", "psg" and "barca" all returned ZERO results (measured)
  // even though the catalogue is full of those shirts. Translate how customers type into
  // how the titles are actually written, before the query is scoped.
  var KD_SEARCH_ALIASES = {
    'man utd': 'manchester united', 'man united': 'manchester united',
    'manutd': 'manchester united', 'utd': 'manchester united', 'mufc': 'manchester united',
    'man city': 'manchester city', 'mcfc': 'manchester city',
    'spurs': 'tottenham', 'thfc': 'tottenham',
    'psg': 'paris saint-germain', 'paris sg': 'paris saint-germain',
    'barca': 'barcelona', 'fcb': 'barcelona',
    'juve': 'juventus', 'gunners': 'arsenal',
    'real': 'real madrid', 'bvb': 'borussia dortmund',
    'inter': 'inter milan', 'lfc': 'liverpool', 'cfc': 'chelsea',
    'nufc': 'newcastle', 'toon': 'newcastle', 'hammers': 'west ham',
    'wolves': 'wolverhampton', 'boro': 'middlesbrough', 'saints': 'southampton',
    'villa': 'aston villa'
  };
  function kdAlias(raw) {
    var q = String(raw || '').trim().toLowerCase().replace(/\s+/g, ' ');
    if (!q) return q;
    if (KD_SEARCH_ALIASES[q]) return KD_SEARCH_ALIASES[q];
    var keys = Object.keys(KD_SEARCH_ALIASES).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (k.indexOf(' ') !== -1 && q.indexOf(k + ' ') === 0) return KD_SEARCH_ALIASES[k] + q.slice(k.length);
    }
    var parts = q.split(' ');
    if (parts.length > 1) {
      var changed = false;
      // `real`, `inter` and `utd` are legitimate FIRST WORDS of other clubs
      // (Real Betis / Sociedad, Inter Miami, "<club> utd"). Expanding them on
      // the per-word path injects a second club name, and kdScopeQ ANDs every
      // word, so the query could never match anything. Deny them here only —
      // the whole-query and multi-word-prefix paths above still expand
      // `real`, `inter` and `man utd` exactly as before. `utd` becomes the
      // plain word `united` instead, which is what "leeds utd" wants.
      // The string deny-list + hasOwnProperty keep a query word like
      // "constructor" from pulling a value off Object.prototype.
      var KD_ALIAS_WORD_DENY = ' real inter utd ';
      for (var j = 0; j < parts.length; j++) {
        if (parts[j] === 'utd') { parts[j] = 'united'; changed = true; continue; }
        if (KD_ALIAS_WORD_DENY.indexOf(' ' + parts[j] + ' ') !== -1) continue;
        if (Object.prototype.hasOwnProperty.call(KD_SEARCH_ALIASES, parts[j])) {
          parts[j] = KD_SEARCH_ALIASES[parts[j]]; changed = true;
        }
      }
      if (changed) return parts.join(' ');
    }
    return q;
  }

function kdScopeQ(raw) {
    var words = String(kdAlias(raw) || '').replace(/["'()*:\\]/g, ' ').split(/\s+/).filter(Boolean);
    if (!words.length) return null;
    var out = [];
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      var t = 'title:' + w + (i === words.length - 1 ? '*' : '');
      out.push('(' + t + ' OR vendor:' + w + ' OR product_type:' + w + ')');
    }
    return out.join(' ');
  }
  function kdUnscopeQ(q) {
    var m = String(q).match(/\(title:[^\s)]+/g);
    if (!m) return q;
    var words = [];
    for (var i = 0; i < m.length; i++) words.push(m[i].slice(7).replace(/\*+$/, ''));
    return words.join(' ');
  }
  window.kdScopeQ = kdScopeQ; // predictive-search.js scopes its View-all count

  // Submit: navigate to the scoped URL. The visible input is never mutated,
  // and because the native submit is cancelled Chrome saves nothing for q.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    if ((f.getAttribute('action') || '').indexOf('/search') === -1) return;
    var qi = f.querySelector('input[name="q"]');
    if (!qi || !qi.value || kdIsScoped(qi.value)) return;
    // Predictive dropdown: a highlighted option means its own handler blocks
    // this submit and clicks the option's link instead — stay out of it.
    var ps = f.closest && f.closest('predictive-search');
    if (ps && ps.querySelector('[aria-selected="true"] a')) return;
    var scoped = kdScopeQ(qi.value);
    if (!scoped) return;
    e.preventDefault();
    var params;
    try {
      params = new URLSearchParams(new FormData(f));
    } catch (err) {
      params = new URLSearchParams();
      params.set('q', qi.value);
    }
    params.set('q', scoped);
    window.location.assign((f.getAttribute('action') || '/search') + '?' + params.toString());
  }, true);

  // Scope /search?q= links as they are clicked (trending terms, predictive
  // "view all", old EDM links) so they land already-scoped.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href*="/search?"]');
    if (!a) return;
    try {
      var u = new URL(a.href, location.origin);
      var q = u.searchParams.get('q');
      if (q && !kdIsScoped(q)) {
        u.searchParams.set('q', kdScopeQ(q) || q);
        a.href = u.toString();
      }
    } catch (err) {}
  }, true);

  // Landing on /search with an unscoped q (bookmark, Google, old link):
  // redirect once to the scoped equivalent, preserving all other params.
  var kdRawTerms = null;
  if (location.pathname.replace(/\/+$/, '') === '/search') {
    try {
      var kdParams = new URLSearchParams(location.search);
      var kdQ = kdParams.get('q');
      if (kdQ && !kdIsScoped(kdQ)) {
        var kdScoped = kdScopeQ(kdQ);
        if (kdScoped) {
          kdParams.set('q', kdScoped);
          location.replace(location.pathname + '?' + kdParams.toString());
        }
      } else if (kdQ) {
        kdRawTerms = kdUnscopeQ(kdQ);
      }
    } catch (err2) {}
  }

  // Cleaner: any VISIBLE search box holding scoped syntax (bfcache restore,
  // session restore, a historical autofill pick) gets the typed words back.
  // Only input[type="search"] — the facets form's HIDDEN q must stay scoped
  // or filter clicks re-run the raw fuzzy search.
  function kdSearchCosmetics() {
    var inputs = document.querySelectorAll('input[type="search"][name="q"]');
    for (var i = 0; i < inputs.length; i++) {
      var v = inputs[i].value;
      if (v && v.indexOf('(title:') !== -1) {
        inputs[i].value = kdRawTerms !== null ? kdRawTerms : kdUnscopeQ(v);
      }
    }
    if (kdRawTerms !== null && document.title.indexOf('(title:') !== -1) {
      document.title = document.title.replace(/\(title:.*\)/, kdRawTerms);
    }
  }
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[type="search"][name="q"]') &&
        t.value && t.value.indexOf('(title:') !== -1) {
      t.value = kdUnscopeQ(t.value);
    }
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kdSearchCosmetics);
  } else {
    kdSearchCosmetics();
  }
  window.addEventListener('load', kdSearchCosmetics);
  window.addEventListener('pageshow', kdSearchCosmetics);
  [0, 300, 800, 1500].forEach(function (t) { setTimeout(kdSearchCosmetics, t); });

  // Quick-search dropdown motion. The theme's own appear-down animation is
  // keyed to a details[open] selector that never matches this header, so the
  // panel popped in with zero transition (and appear-down animates margin-top,
  // a layout property). Animate ONLY the persistent wrappers — the result
  // grid is re-created on every keystroke and animating it would flicker.
  var kdSearchCss =
    '@keyframes kd-search-in{from{opacity:0;transform:translateY(6px)}' +
    'to{opacity:1;transform:translateY(0)}}' +
    'predictive-search[open] .quickSearchResultsWrap[data-predictive-search],' +
    'predictive-search .quickSearchResultsWidget.is-show' +
    '{animation:kd-search-in 180ms cubic-bezier(0.23,1,0.32,1)}' +
    '.search-modal .quickSearchResultsWrap[data-predictive-search],' +
    '.search-modal .quickSearchResultsWrap[data-quick-trending-products]' +
    '{box-shadow:0 8px 24px rgba(0,0,0,.12)}' +
    '@media (prefers-reduced-motion:reduce){' +
    'predictive-search[open] .quickSearchResultsWrap[data-predictive-search],' +
    'predictive-search .quickSearchResultsWidget.is-show{animation:none}}';
  var kdSearchStyle = document.createElement('style');
  kdSearchStyle.setAttribute('data-kd-search', '');
  kdSearchStyle.appendChild(document.createTextNode(kdSearchCss));
  (document.head || document.documentElement).appendChild(kdSearchStyle);
// ==== TKD SEARCH SCOPE v2 (2026-08-02) — END ====
})();

// ── KD Fix: print-system titles (standalone) ─────────────────────────────
// Swap known section headings for ink-type images. Generate new ones with
// scripts/kd_title.py in the tool repo and add a line to the map.
(function () {
  'use strict';
  var KD_TITLES = {
    'GRAILS': 'https://cdn.shopify.com/s/files/1/0573/6307/1160/t/13/assets/kd-title-grails.webp?v=1787228032&width=350',
    '25 26 CLEARANCE 50 OFF': 'https://cdn.shopify.com/s/files/1/0573/6307/1160/t/13/assets/kd-title-25-26-clearance-50-off.webp?v=1787228043&width=1550',
    'SHOP BY COUNTRY': 'https://cdn.shopify.com/s/files/1/0573/6307/1160/t/13/assets/kd-title-shop-by-country.webp?v=1787228049&width=900',
    'APPAREL VINTAGE KITS': 'https://cdn.shopify.com/s/files/1/0573/6307/1160/t/13/assets/kd-title-apparel-vintage-kits.webp?v=1787461198&width=1250'
  };
  function norm(s) { return (s || '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim(); }
  function swap() {
    document.querySelectorAll('.halo-block-header .title, .halo-block-header h2, .halo-block-header h3').forEach(function (t) {
      if (t.querySelector('img.kd-title-img')) return;
      var url = KD_TITLES[norm(t.textContent)];
      if (!url) return;
      var span = t.querySelector('.text') || t;
      var img = document.createElement('img');
      img.src = url; img.alt = t.textContent.trim(); img.className = 'kd-title-img';
      span.textContent = ''; span.appendChild(img);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swap);
  } else { swap(); }
})();


// ── KD Fix: section rhythm — mark outer sections that get the ink rule ────
(function () {
  'use strict';
  var KD_RULE = ['__sale_products', '__most_wanted_products', '__collection_list_',
                 '__custom_service_block_', '__custom_liquid_dgfcfq', '__custom_liquid_7rAB4W'];
  function mark() {
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (!s.id) return;
      for (var i = 0; i < KD_RULE.length; i++) {
        if (s.id.indexOf(KD_RULE[i]) > -1) { s.classList.add('kd-rule'); return; }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mark);
  } else { mark(); }
})();


// ── KD Fix: scroll-reveal safety net ─────────────────────────────────────
// The theme parks every .scroll-trigger element at opacity:.01 until an
// IntersectionObserver clears it. If that JS ever fails (one section's inline
// script was throwing a TypeError before this was written), the content —
// including form submit buttons and the whole footer — stays invisible.
// This forces anything still hidden near the viewport to show itself.
(function () {
  'use strict';
  // PERF 2026-08-24: this used to call getComputedStyle() AND
  // getBoundingClientRect() on EVERY .scroll-trigger, once a second, whether
  // or not anything was actually hidden. A collection page has 66 of them, so
  // that was 66 forced style+layout flushes per second — read/write
  // interleaved, which is textbook layout thrashing — and it ran while you
  // were scrolling. Now: match the hidden ones with a cheap selector first and
  // bail if there are none (the normal case costs nothing), then do ALL the
  // reads before ANY of the writes so the layout is flushed once, not N times.
  function kdRevealSafetyNet() {
    var els = document.querySelectorAll(
      '.scroll-trigger--offscreen, .scroll-trigger[style*="opacity: 0"]'
    );
    if (!els.length) return true;                    // nothing hidden — free
    var vh = window.innerHeight || 800;
    var reveal = [], i;
    for (i = 0; i < els.length; i++) {               // ---- reads only ----
      var r = els[i].getBoundingClientRect();
      if (r.top > vh * 1.5 || r.bottom < -vh) continue;   // far off-screen
      reveal.push(els[i]);
    }
    for (i = 0; i < reveal.length; i++) {            // ---- writes only ----
      reveal[i].style.opacity = '1';
      reveal[i].style.transform = 'none';
      reveal[i].classList.remove('scroll-trigger--offscreen');
    }
    return false;
  }
  var t = 0, quiet = 0;
  var iv = setInterval(function () {
    if (kdRevealSafetyNet()) { quiet++; } else { quiet = 0; }
    // stop early once the page has settled — no reason to keep polling
    if (quiet >= 3 || ++t > 20) clearInterval(iv);
  }, 1000);
  window.addEventListener('load', kdRevealSafetyNet);
})();

// ==== KD FIX — mobile short country labels (2026-08-23) — START ====
// The SHOP BY COUNTRY tiles are 108px wide on a 375px phone and the theme
// clips the caption (nowrap + overflow:hidden), so UNITED KINGDOM rendered as
// "UNITED KINGDO". The h3 keeps its real text for a11y/SEO; kd-base.css prints
// data-kd-short instead below 768px.
(function () {
  'use strict';
  var SHORT = {
    'UNITED KINGDOM': 'UK', 'FRENCH CLUBS': 'FRANCE', 'SPANISH CLUBS': 'SPAIN',
    'GERMAN CLUBS': 'GERMANY', 'ITALIAN CLUBS': 'ITALY', 'INTERNATIONAL': 'WORLD',
    'REST OF WORLD': 'REST OF WORLD'
  };
  function norm(s) { return (s || '').toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim(); }
  function stamp() {
    document.querySelectorAll('.section-collection-list .card__heading').forEach(function (h) {
      var s = SHORT[norm(h.textContent)];
      if (s && h.getAttribute('data-kd-short') !== s) h.setAttribute('data-kd-short', s);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stamp);
  } else { stamp(); }
  window.addEventListener('load', stamp);
  setTimeout(stamp, 1200);
})();
// ==== KD FIX — mobile short country labels — END ====

// ==== KD BUY PATH — ONE-TAP MOBILE ATC + FIRSTKIT NOTE (2026-08-27) ====
// Appended to the LIVE assets/kd-fixes.js by scripts/deploy_kd_fixes_append.py.
// The live bundle is minified and AHEAD of theme/assets/kd-fixes.js — never
// deploy the repo copy over it. Self-contained IIFE; declares no identifier
// that exists in the live bundle (all state is inside this closure).
(function () {
  'use strict';

  // ── KDCO-J1. one-tap add to cart on phones ────────────────────────────────
  // At <=767px the theme hides BOTH in-flow buy buttons (measured 0x0) and the
  // only visible "Add to cart" is #show-sticky-product — a placeholder with no
  // name attribute that is not in any form. Tapping it fires zero /cart/add
  // requests; it just opens a bottom sheet where the buyer picks the size AGAIN
  // and taps the real button. Two taps and a redundant choice on a catalogue
  // that is overwhelmingly one-of-one single-size shirts — and "Buy with Shop"
  // right below it adds in one tap, so express checkout was easier than the
  // cart.
  //
  // When the product has exactly one variant, it is available, and the sticky
  // form already carries that variant id (the theme's VariantSticky* elements
  // keep input[name=id] synced), the sheet asks a question with one answer. So
  // we suppress it and click the real submit inside the sticky form — the exact
  // path that fires the theme's AJAX and opens the drawer.
  //
  // Anything unexpected — more than one variant, sold out, id mismatch, missing
  // node, bad JSON — falls through untouched and the buyer gets the sheet. A
  // multi-size shirt must never be added without the size being chosen.
  var busy = false;

  function stickyRootFor(el) {
    return (el.closest && el.closest('.productView-stickyCart')) ||
      document.querySelector('.productView-stickyCart');
  }

  function soleAvailableVariant(root) {
    var node = root.querySelector('script[type="application/json"]');
    if (!node) return null;
    var list;
    try { list = JSON.parse(node.textContent); } catch (e) { return null; }
    if (!list || list.length !== 1) return null;
    return list[0] && list[0].available ? list[0] : null;
  }

  document.addEventListener('click', function (e) {
    try {
      if (busy) return;
      var opener = e.target && e.target.closest && e.target.closest('#show-sticky-product');
      if (!opener) return;
      if (window.innerWidth > 767) return;

      var root = stickyRootFor(opener);
      if (!root) return;
      var form = root.querySelector('form[id^="product-form-sticky-"]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var submit = form.querySelector('button[name="add"]');
      if (!idInput || !submit || submit.disabled) return;

      var variant = soleAvailableVariant(root);
      if (!variant || String(variant.id) !== String(idInput.value)) return;

      // Beat StickyAddToCart.openStickyModal, which is bound on the button
      // itself and therefore runs in the bubble phase.
      e.preventDefault();
      e.stopPropagation();

      busy = true;
      window.setTimeout(function () { busy = false; }, 1500);
      submit.click();
    } catch (err) { /* fall through to the sheet */ }
  }, true);

  // ── KDCO-J2. carry the FIRSTKIT promise to the cart ───────────────────────
  // The PDP promises "Free AU shipping on your first order — use code FIRSTKIT
  // at checkout" and then drops it: FIRSTKIT appears zero times in the drawer,
  // on the cart page, or in the checkout, where the buyer meets a bare
  // "Discount code or gift card" box. The code is live (100% off the shipping
  // line, once per customer, no expiry — verified in Shopify 2026-08-27).
  //
  // Also fixes the drawer's edit button, which carries title="Remove L" while
  // it actually opens the size editor — screen readers announce the wrong
  // action on the one control that changes a size.
  var NOTE_CLASS = 'kd-firstkit-note';
  var NOTE_HTML = 'First order? Free AU shipping with code <b>FIRSTKIT</b> at checkout.';

  function makeNote() {
    var el = document.createElement('div');
    el.className = NOTE_CLASS;
    el.innerHTML = NOTE_HTML;
    return el;
  }

  function mountNote(container, before) {
    if (!container || container.querySelector('.' + NOTE_CLASS)) return;
    if (before && before.parentNode === container) container.insertBefore(makeNote(), before);
    else container.appendChild(makeNote());
  }

  function relabelEditButtons() {
    var buttons = document.querySelectorAll('#halo-cart-sidebar .previewCartItem-edit');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      if (b.getAttribute('data-kd-relabelled') === '1') continue;
      b.setAttribute('data-kd-relabelled', '1');
      b.setAttribute('title', 'Edit size');
      b.setAttribute('aria-label', 'Edit size');
    }
  }

  function paint() {
    try {
      // drawer — above the checkout buttons, only when the cart has something
      var info = document.querySelector('#halo-cart-sidebar .previewCartInfo');
      if (info && document.querySelector('#halo-cart-sidebar .previewCartItem')) {
        mountNote(info, info.querySelector('.previewCartAction'));
      }
      // cart page — directly above "Proceed to checkout"
      var group = document.querySelector('.cart-actions .action-group');
      if (group && document.getElementById('cart-checkout')) {
        mountNote(group, document.getElementById('cart-checkout'));
      }
      relabelEditButtons();
    } catch (err) { /* never break the cart */ }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; paint(); });
  }

  // Halo replaces the whole .previewCart wrapper on every ajax cart change, so
  // the note has to be re-mounted after each one. The observer is the only
  // signal that survives every path into the drawer (add, qty, remove, upsell),
  // so install it defensively: this file is loaded from <head>, where
  // document.body is still null, and a retry on DOMContentLoaded means a null
  // root can never silently cost us the observer.
  var observing = false;
  function watchCart() {
    if (observing) return;
    var root = document.body || document.documentElement;
    if (!root) return;
    try {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes && records[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(root, { childList: true, subtree: true });
      observing = true;
    } catch (err) { /* retried on DOMContentLoaded */ }
  }

  function start() { watchCart(); paint(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  watchCart();
  window.addEventListener('load', start);
  [300, 900, 1800].forEach(function (t) { window.setTimeout(start, t); });
})();
